export default __webpack_public_path__ + "static/media/waya_business_banking_v2.fdbcdba6.png";